'use strict';

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _withTranslators = require('../withTranslators.js');

var _withTranslators2 = _interopRequireDefault(_withTranslators);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var messagePropType = function messagePropType(otherPropName) {
  return (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (props) {
    return !props[otherPropName];
  }, 'T requires either a message prop or a child node in the form of a pure string');
};

var T = function (_Component) {
  _inherits(T, _Component);

  function T() {
    _classCallCheck(this, T);

    return _possibleConstructorReturn(this, (T.__proto__ || Object.getPrototypeOf(T)).apply(this, arguments));
  }

  _createClass(T, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          message = _props.message,
          messagePlural = _props.messagePlural,
          context = _props.context,
          count = _props.count,
          children = _props.children,
          tcnp = _props.tcnp,
          transformInput = _props.transformInput,
          scope = _objectWithoutProperties(_props, ['message', 'messagePlural', 'context', 'count', 'children', 'tcnp', 'transformInput']);

      delete scope.t;
      delete scope.tp;
      delete scope.tn;
      delete scope.tnp;
      delete scope.tc;
      delete scope.tcp;
      delete scope.tcn;
      var msgid = message || children || '';
      var translatedContent = tcnp(context, transformInput(msgid), transformInput(messagePlural), count, _extends({}, scope, {
        count: count
      }));
      return typeof translatedContent === 'string' ? _react2.default.createElement('span', null, translatedContent) : translatedContent;
    }
  }]);

  return T;
}(_react.Component);

T.propTypes = {
  message: messagePropType('children'),
  children: messagePropType('messages'),
  messagePlural: _propTypes2.default.string,
  context: _propTypes2.default.string,
  count: _propTypes2.default.number,
  tcnp: _propTypes2.default.func.isRequired,
  transformInput: _propTypes2.default.func.isRequired
};
T.defaultProps = {
  message: null,
  children: null,
  messagePlural: null,
  context: '',
  count: 1
};
exports.default = (0, _withTranslators2.default)(T);